import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PasswordCriteriasComponent } from './password-criterias.component';
import { MaterialModule } from 'src/app/shared/material.module';

@NgModule({
  declarations: [PasswordCriteriasComponent],
  imports: [CommonModule, MaterialModule],
  exports: [PasswordCriteriasComponent],
})
export class PasswordCriteriasModule {}
